import { createStyles, makeStyles } from '@mui/styles';
import Colors from '../../layout/theme-next/colors';
import { NextTheme } from '../../layout/theme-next/provider';

export const styles = makeStyles((theme: NextTheme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      width: 'auto',
      height: 'max-content',
      backgroundColor: theme.palette.common.white,
    },
    container: {
      width: 500,
      marginTop: 40,
      [theme.media.mobile]: {
        width: '100%',
        padding: theme.spacing(3),
        marginTop: theme.spacing(0.24),
      },
    },
    title: {
      fontSize: 26,
      [theme.media.mobile]: {
        textAlign: 'center',
      },
    },
    subtitle: {
      marginBottom: 40,
      fontSize: 16,
      fontWeight: 300,
      [theme.media.mobile]: {
        textAlign: 'center',
      },
    },
    avatar: {
      width: 58,
      height: 58,
      borderRadius: '50%',
      border: '1px solid lightgrey',
    },
    companyButton: {
      background: 'none',
      color: 'inherit',
      border: 'none',
      padding: 0,
      font: 'inherit',
      cursor: 'pointer',
      outline: 'inherit',
      fontSize: 18,
      width: 480,
      height: 100,
      textAlign: 'justify',
      borderBottom: '1px solid lightgrey',
      [theme.media.mobile]: {
        width: '100%',
      },
    },
    company: {
      display: 'flex',
    },
    companyName: {
      margin: '18px 0 18px 16px',
    },
    switchclosemobile: {
      display: 'none',
      [theme.media.mobile]: {
        width: 30,
        height: 30,
        top: theme.spacing(1.3),
        padding: theme.spacing(1),
        borderRadius: 4,
        backgroundColor: Colors.hover,
        marginLeft: '90%',
        display: 'unset',
        position: 'relative', // Add if needed to fix positioning
      },
    },
    selectedIcon: {
      display: 'none',
      [theme.media.mobile]: {
        color: Colors.statusDraft,
        fontSize: 18,
        fontWeight: 900,
        marginLeft: theme.spacing(10),
        marginTop: theme.spacing(2),
        display: 'unset',
      },
    },
    lessThentwo: {
      [theme.breakpoints.between('sm', 'md')]: {
        overflow: 'scroll',
        height: 200,
      },
    },
  }),
);
